import { Form, Modal } from "antd";
import React from "react";
import { CreateWaterJournalDto } from "../../../api";
import { WaterJournalsColumns } from "../form/columns";

interface WaterJournalsFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateWaterJournal: (values: CreateWaterJournalDto) => void;
  organizationId?: string;
}

export const WaterJournalForm: React.FC<WaterJournalsFormProps> = ({ visible, setVisible, onCreateWaterJournal, organizationId }) => {
  const [form] = Form.useForm<CreateWaterJournalDto>();

  const onChange = (value: any, additional?: any) => {

    (Object.keys(form.getFieldsValue()) as (keyof CreateWaterJournalDto)[]).find((key) => {
      return form.getFieldsValue()[key] === value;
    });

  }

  return (
    <Modal width="60%" open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateWaterJournal}>
        {WaterJournalsColumns().map(({ title, dataIndex, rules, inputNode }, index) => (
          <Form.Item label={title} name={dataIndex} rules={rules} key={index}>
            {
              React.cloneElement(
                inputNode,
                {
                  onChange: onChange
                }
              )
            }
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};
